module.exports = __webpack_public_path__ + "img/web-simpp.363f302a.jpg";